<template>
  <div>
    <h1 class="center">{{$t('login')}}</h1>
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item :validate-status="error('email') ? 'error' : ''" :help="error('email') || ''">
        <a-input
          v-decorator="[
          'email',
          {  rules: [
              {
                type: 'email',
                message: 'The input is not valid E-mail!',
              },
              {
                required: true,
                message: 'Please input your E-mail!',
              },
            ]}]"
          placeholder="email"
        >
          <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item
        :validate-status="error('password') ? 'error' : ''"
        :help="error('password') || ''"
      >
        <a-input-password
          placeholder="Password"
          v-decorator="[
          'password',
          { rules: [{ required: true, message: 'Please input your Password!' }] },
        ]"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input-password>
      </a-form-item>
      <a-form-item>
        <a-button type="link">
          <router-link to="/signup">{{$t('signup')}}</router-link>
        </a-button>
        <a-button
          type="primary"
          html-type="submit"
          :loading="processing"
          :disabled="hasErrors(form.getFieldsError())"
        >{{$t('login')}}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { hasErrors } from "../utils.js";
import { mapActions } from "vuex";
import fb from "../firebaseConfig.js";
// import { LOGIN_LOADING, LOGIN_SUCCESS, LOGIN_ERROR } from "../store/constants";
export default {
  name: "login",
  components: {},
  // computed: {
  //   ...mapState({
  //     success: state => state[LOGIN_SUCCESS],
  //     err: state => state[LOGIN_ERROR]
  //   })
  // },
  data() {
    return {
      processing: false,
      hasErrors,
      form: this.$form.createForm(this, { name: "Login Form" })
    };
  },
  methods: {
    ...mapActions({ login: "auth/login" }),
    error(name) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(name) && getFieldError(name);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, { email, password }) => {
        if (!err) {
          this.processing = true;
          this.login({
            email,
            password
          })
            .then(d => {
              this.processing = false;
              this.$router.push("/");
            })
            .catch(err => (this.processing = false));
        }
      });
    }
  }
};
</script>


<style lang="less" scoped>
@import "../styles/variables.less";
form {
  text-align: left;
  max-width: 640px;
  margin: 0 auto;
}
.extras {
  margin-top: 8px;
}
</style>